import { useEffect, useState } from "react"
import { layoutModeTypes, useLayoutStore } from "store/useLayoutStore"

const useIsDarkTheme = () => {
  const [isDarkTheme, setIsDarkTheme] = useState(
    localStorage.getItem("theme") == layoutModeTypes.DARK
  )
  const storeTheme = useLayoutStore(state => state.layoutModeType)

  useEffect(() => {
    setIsDarkTheme(storeTheme == layoutModeTypes.DARK ? true : false)
  }, [storeTheme])

  return isDarkTheme
}

export default useIsDarkTheme
